<template>
  <div class="app">
    <!-- 인트로 화면 (PC만) - 커튼 오픈 -->
    <div v-if="!isMobile" class="intro-overlay" :class="{ open: introOpen }">
      <!-- 왼쪽 커튼 -->
      <div class="curtain curtain-left">
        <div class="curtain-inner"></div>
      </div>
      <!-- 오른쪽 커튼 -->
      <div class="curtain curtain-right">
        <div class="curtain-inner"></div>
      </div>

      <!-- 중앙 콘텐츠 -->
      <div class="intro-content" :class="{ hide: introOpen }">
        <h1 class="intro-title">테크노 레이원시티</h1>
        <p class="intro-sub">TECHNO RAYONE CITY</p>
      </div>
    </div>

    <!-- 메인 콘텐츠 -->
    <div class="site-wrapper" :class="{ show: isMobile || introComplete }">
      <AppHeader />

      <!-- 모바일 프로모션 바 (헤더 바로 아래) -->
      <MobilePromoBar v-if="isMobile" @open-form="openReservationForm" />

      <main class="main-content" :class="{ 'mobile': isMobile }">
        <router-view :is-mobile="isMobile" @open-form="openReservationForm" />
      </main>

      <AppFooter />

      <!-- PC: 기존 플로팅 -->
      <FloatingContact v-if="!isMobile" />

      <!-- 모바일: 플로팅 버튼 + 하단 배너 -->
      <template v-if="isMobile">
        <MobileFloating @open-form="openReservationForm" />
        <MobileBottomBanner @open-form="openReservationForm" />
      </template>

      <!-- 모바일: 방문예약 모달 -->
      <MobileReservationModal
        v-if="isMobile"
        :is-open="isReservationOpen"
        @close="closeReservationForm"
      />

      <!-- 첫 진입 관심고객 등록 팝업 (PC + 모바일) -->
      <MobileRegisterPopup v-if="isMobile || introComplete" />
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'
import FloatingContact from '@/components/common/FloatingContact.vue'

// 모바일 컴포넌트
import MobilePromoBar from '@/components/mobile/MobilePromoBar.vue'
import MobileFloating from '@/components/mobile/MobileFloating.vue'
import MobileBottomBanner from '@/components/mobile/MobileBottomBanner.vue'
import MobileReservationModal from '@/components/mobile/MobileReservationModal.vue'
import MobileRegisterPopup from '@/components/mobile/MobileRegisterPopup.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    FloatingContact,
    MobilePromoBar,
    MobileFloating,
    MobileBottomBanner,
    MobileReservationModal,
    MobileRegisterPopup
  },
  data() {
    return {
      isMobile: false,
      breakpoint: 768,
      introOpen: false,
      introComplete: false,
      isReservationOpen: false
    }
  },
  mounted() {
    this.checkDevice()
    window.addEventListener('resize', this.checkDevice)

    if (!this.isMobile) {
      this.startIntro()
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkDevice)
  },
  methods: {
    checkDevice() {
      this.isMobile = window.innerWidth <= this.breakpoint
    },
    startIntro() {
      setTimeout(() => { this.introOpen = true }, 1500)
      setTimeout(() => { this.introComplete = true }, 2500)
    },
    openReservationForm() {
      this.isReservationOpen = true
    },
    closeReservationForm() {
      this.isReservationOpen = false
    }
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/wanteddev/wanted-sans/packages/wanted-sans/fonts/webfonts/variable/split/WantedSansVariable.min.css');

:root {
  --main-color1: #8B2332;
  --main-color2: #5C1520;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Wanted Sans Variable', 'Wanted Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow-x: hidden;
}

a {
  text-decoration: none;
  color: inherit;
}

.main-content {
  padding-top: 80px;
}

/* 모바일 메인 콘텐츠 */
.main-content.mobile {
  padding-top: 120px;
  padding-bottom: 70px;
}

@media (max-width: 1024px) {
  .main-content {
    padding-top: 60px;
  }
}

/* ==================== */
/* 커튼 오픈 인트로 */
/* ==================== */
.intro-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999;
  pointer-events: none;
}

.intro-overlay.open {
  pointer-events: none;
}

.curtain {
  position: absolute;
  top: 0;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: transform 1s cubic-bezier(0.76, 0, 0.24, 1);
}

.curtain-left { left: 0; }
.curtain-right { right: 0; }

.curtain-inner {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--main-color1) 0%, var(--main-color2) 100%);
}

.intro-overlay.open .curtain-left { transform: translateX(-100%); }
.intro-overlay.open .curtain-right { transform: translateX(100%); }

.intro-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 10;
  transition: opacity 0.5s ease;
}

.intro-content.hide { opacity: 0; }

.intro-title {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -1px;
  margin-bottom: 16px;
  animation: fadeInUp 0.8s ease 0.3s forwards;
  opacity: 0;
}

.intro-sub {
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 6px;
  animation: fadeInUp 0.8s ease 0.5s forwards;
  opacity: 0;
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.site-wrapper {
  opacity: 0;
  transition: opacity 0.6s ease;
}

.site-wrapper.show { opacity: 1; }

@media (max-width: 768px) {
  .intro-title { font-size: 28px; }
  .intro-sub { font-size: 12px; letter-spacing: 3px; }
}
</style>
